<!-- vueui/src/App.vue -->
<template>
  <div class="d-flex flex-column min-vh-100 bg-light">
    <div v-if="showAppUpdatePrompt" class="app-update-banner alert alert-warning" role="alert">
      <span class="app-update-text">Website has been updated. Refresh now?</span>
      <div class="app-update-actions">
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="dismissAppUpdatePrompt">
          Later
        </button>
        <button type="button" class="btn btn-sm btn-warning" @click="refreshAppNow">
          Refresh
        </button>
      </div>
    </div>
    <TopNavbar />
    <main class="flex-grow-1">
      <RouterView />
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import TopNavbar from './components/TopNavbar.vue'
import Footer from './components/Footer.vue'
import {
  dismissAppUpdatePrompt,
  refreshAppNow,
  showAppUpdatePrompt
} from './composables/useAppUpdate'
</script>

<style>
/* Optional: remove body margin globally if not already done in main.css */
body {
  margin: 0;
  padding: 0;
  /* background-color: #80c192; */
  /* background-color: #5f99d3; */
  /* light gray to match bg-light */
}

.app-update-banner {
  margin: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  position: sticky;
  top: 0;
  z-index: 1031;
}

.app-update-text {
  font-weight: 500;
}

.app-update-actions {
  display: flex;
  gap: 0.5rem;
}
</style>
